export class ArticalModel {
    id:string;
    referenceId:string;
    entityId:string;
    nameAr: string ;
    nameEn:string;
    contentAr:string;
    showContent:any;
    showTitle:string;
    menuCode:string;

    contentEn:string
  }
